import React from 'react';
import { Gift, CheckCircle2 } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    id: 1,
    icon: '📖',
    title: 'Cómo ayudar a tu hijo a leer mejor',
    image: 'https://cdn.magicpatterns.com/uploads/iN4WErT3sCtjYjogQktAZS/bono_1.png',
    desc: 'Una guía práctica para acompañar el proceso de lectura. Aprenderás:',
    bullets: ['cómo estimular el interés por la lectura', 'técnicas para mejorar la comprensión lectora', 'estrategias simples para apoyar la alfabetización']
  }, {
    id: 2,
    icon: '🔢',
    title: 'Cómo desarrollar el pensamiento matemático en tu hijo',
    image: 'https://cdn.magicpatterns.com/uploads/j1rd3o8RdQo6iyJo1zPtFd/bono_2.png',
    desc: 'Descubre cómo ayudar a tu hijo a comprender las matemáticas de forma natural. Incluye:',
    bullets: ['actividades para estimular el razonamiento', 'juegos para desarrollar el pensamiento lógico', 'formas simples de aprender matemáticas en casa']
  }, {
    id: 3,
    icon: '📚',
    title: 'Pequeños cuentos para grandes pensamientos',
    image: 'https://cdn.magicpatterns.com/uploads/rSrfQD4DZuJ3b6xJt4yuzb/bono_3.png',
    desc: 'Una colección de cuentos pensados para estimular:',
    bullets: ['la reflexión', 'la comprensión', 'la imaginación', 'el pensamiento crítico'],
    footer: 'Perfectos para compartir momentos de lectura con tu hijo.'
  }];
  return <section className="w-full bg-white py-16 px-4" data-id="element-38">
      <div className="max-w-5xl mx-auto" data-id="element-39">
        <div className="text-center mb-16" data-id="element-40">
          
          <div className="inline-flex items-center justify-center bg-red-100 text-red-800 px-6 py-3 rounded-full" data-id="element-41">
            <Gift className="w-6 h-6 mr-2" data-id="element-42" />
            <span className="text-2xl font-bold" data-id="element-43">
              Además recibirás 3 BONUS incluidos
            </span>
          </div>
        </div>

        <div className="space-y-16" data-id="element-44">
          {bonuses.map(bonus => <div key={bonus.id} className="flex flex-col md:flex-row items-center gap-8 bg-gray-50 rounded-3xl p-8 border-2 border-gray-100 shadow-xl" data-id="element-45">
              <div className="w-full md:w-1/2 flex justify-center" data-id="element-46">
                <img src={bonus.image} alt={`Bonus ${bonus.id}: ${bonus.title}`} className="w-full max-w-[1080px] h-auto object-contain drop-shadow-2xl bg-transparent" style={{
              aspectRatio: '1/1'
            }} data-id="element-47" />
              </div>

              <div className="w-full md:w-1/2" data-id="element-48">
                <div className="inline-block bg-red-600 text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider mb-4" data-id="element-49">
                  Bonus {bonus.id}
                </div>
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 flex items-start" data-id="element-50">
                  <span className="mr-3" data-id="element-51">{bonus.icon}</span>
                  {bonus.title}
                </h3>

                <p className="text-lg text-gray-700 font-medium mb-6" data-id="element-52">
                  {bonus.desc}
                </p>

                <ul className="space-y-3 mb-6" data-id="element-53">
                  {bonus.bullets.map((bullet, idx) => <li key={idx} className="flex items-start" data-id="element-54">
                      <CheckCircle2 className="h-6 w-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-55" />
                      <span className="text-lg text-gray-800" data-id="element-56">{bullet}</span>
                    </li>)}
                </ul>

                {bonus.footer && <p className="text-lg font-bold text-blue-600 bg-blue-50 p-4 rounded-lg" data-id="element-57">
                    {bonus.footer}
                  </p>}
              </div>
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-58">
          <div className="inline-block animate-bounce bg-yellow-400 text-black px-8 py-4 rounded-full shadow-lg border-4 border-yellow-500 mb-8" data-id="element-59">
            <span className="text-2xl md:text-3xl font-black uppercase" data-id="element-60">
              ¡ESTOS BONOS SON GRATIS POR EL DÍA DE HOY!
            </span>
          </div>
        </div>
      </div>
    </section>;
}